// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.81.0/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"8760088fd1a650d9959e","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};